/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Average_Per_YearInputs */



/**
* | output |
* | --- |
* | "Average per year" |
*
* @param {Consumption_Average_Per_YearInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_average_per_year = /** @type {((inputs?: Consumption_Average_Per_YearInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Average_Per_YearInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Average per year")
	return /** @type {LocalizedString} */ ("Moyenne par an")
});